module.exports = __webpack_public_path__ + "static/media/template-products-food.42df7c73.csv";